import React from "react";
import {
  MDSButton,
  MDSButtonGroup,
  MDSButtonVariant,
  MDSDialog,
  MDSDialogSlotName,
  MDSDialogTextContent,
  MDSPopover,
  MDSText,
  MDSTextVariant,
  MDSTextWeight,
} from "@/mds";
import { pluralize } from "@/modules/pluralize";

interface ClearFiltersModalProps {
  isOpen: boolean;
  count: number;
  onCancel: () => void;
  onConfirm: () => void;
  triggerRef: React.RefObject<Element>;
}

export const ClearFiltersModal: React.FC<ClearFiltersModalProps> = ({
  isOpen,
  count,
  onCancel,
  onConfirm,
  triggerRef,
}) => {
  return (
    <MDSPopover
      styling={false}
      triggerRef={triggerRef}
      isOpen={isOpen}
      onOpenChange={value => {
        if (!value) onCancel();
      }}
      shouldCloseOnInteractOutside={() => true}
      isNonModal
    >
      <MDSDialog isOpen={isOpen} handleClose={onCancel} fluidWidth isDismissable={false}>
        <MDSDialogTextContent slot={MDSDialogSlotName.Content}>
          <MDSText variant={MDSTextVariant.ParagraphS} weight={MDSTextWeight.SemiBold}>
            Remove {count} {pluralize(count, "filter", "filters")}?
          </MDSText>
          <MDSText variant={MDSTextVariant.ParagraphS}>
            To hide all filters, {count} active {pluralize(count, "filter", "filters")} will be
            removed
          </MDSText>
        </MDSDialogTextContent>
        <MDSButtonGroup slot={MDSDialogSlotName.ButtonsRight}>
          <MDSButton onClick={onCancel}>Cancel</MDSButton>
          <MDSButton variant={MDSButtonVariant.DangerFilled} onClick={onConfirm}>
            Remove {pluralize(count, "filter", "filters")}
          </MDSButton>
        </MDSButtonGroup>
      </MDSDialog>
    </MDSPopover>
  );
};
